(async () => {
    if (!customElements.get("product-media-slider")) {
        const {
            Fancybox
        } = await import("./fancybox.esm-575fa3d8.async.js");
        class ProductMediaSlider extends HTMLElement {
            constructor() {
                super();
                this.thumbSlider();
                this.mainSlider();
                this.fancybox();
                this.reducer = {
                    slideToVariant: e => this.slideToVariant(e)
                };
                document.addEventListener("variant-change", this.reducer.slideToVariant)
            }
            thumbSlider() {
                if (!Swiper) {
                    return false
                }
                this.swiperThumbs = this.querySelector("[data-product-media-thumbnails-slider]");
                this.thumbbuttonPrev = this.querySelector(".swiper-thumb-button-next");
                this.thumbbuttonNext = this.querySelector(".swiper-thumb-button-prev");
                this.swiperThumbsOptions = {
                    spaceBetween: 4,
                    observer: true,
                    threshold: 10,
                    direction: "vertical",
                    slidesPerView: "auto",
                    watchSlidesProgress: true,
                    navigation: {
                        nextEl: this.thumbbuttonNext,
                        prevEl: this.thumbbuttonPrev
                    }
                };
                this.swiperThumbsInstance = new Swiper(this.swiperThumbs, this.swiperThumbsOptions);
                if (Shopify.designMode && this.swiperThumbsInstance) {
                    window.addEventListener("shopify:section:load", (() => {
                        setTimeout((() => {
                            this.swiperThumbsInstance.update()
                        }), 300)
                    }))
                }
            }
            mainSlider() {
                if (typeof Swiper == "undefined") {
                    return false
                }
                this.swiperMain = this.querySelector("[data-product-media-slider]");
                this.buttonPrev = this.querySelector(".swiper-button-prev");
                this.buttonNext = this.querySelector(".swiper-button-next");
                let thumbOptions;
                if (this.swiperThumbsInstance) {
                    thumbOptions = {
                        thumbs: {
                            swiper: this.swiperThumbsInstance
                        }
                    }
                }
                let initialSlideIndex = 0;
                const initalVariant = parseInt(this.swiperMain.dataset.productMediaSlider);
                if (initalVariant) {
                    const initialSlide = this.matchVariantIdWithSlide(initalVariant);
                    initialSlideIndex = initialSlide ? initialSlide : initialSlideIndex
                }
                const videoFirst = this.getAttribute("data-video-first");
                if (videoFirst == "true") {
                    const videoSlideIndex = this.getVideoSlideIndex();
                    if (videoSlideIndex !== -1) {
                        initialSlideIndex = videoSlideIndex
                    }
                } else {
                    const initalVariant = parseInt(this.swiperMain.dataset.productMediaSlider);
                    if (initalVariant) {
                        const initialSlide = this.matchVariantIdWithSlide(initalVariant);
                        initialSlideIndex = initialSlide ? initialSlide : initialSlideIndex
                    }
                }
                this.swiperMainOptions = {
                    observer: true,
                    threshold: 10,
                    direction: "horizontal",
                    initialSlide: initialSlideIndex,
                    navigation: {
                        nextEl: this.buttonNext,
                        prevEl: this.buttonPrev
                    },
                    ...thumbOptions,
                    breakpoints: {
                        320: {
                            slidesPerView: 1.5,
                            spaceBetween: 15,
                            loop: true,
                            navigation: false,
                        },
                        768: {
                            slidesPerView: 1,
                        }
                    }
                };
                this.swiperMainInstance = new Swiper(this.swiperMain, this.swiperMainOptions);
                if (Shopify.designMode && this.swiperMainInstance) {
                    window.addEventListener("shopify:section:load", (() => {
                        this.swiperMainInstance.update()
                    }))
                }
            }
            getVideoSlideIndex() {
                if (!this.swiperMain) {
                    return -1
                }
                const slides = this.swiperMain.querySelectorAll("[data-product-variant-image]");
                for (let i = 0; i < slides.length; i++) {
                    const slide = slides[i];
                    const mediaItem = slide.querySelector(".product-media-slider__item");
                    if (mediaItem && mediaItem.dataset.mediaType == "video") {
                        console.log("i:", i);
                        return i
                    }
                }
                return -1
            }
            fancybox() {
                if (typeof Swiper == "undefined") {
                    return false
                }
                Fancybox.bind("[data-fancybox]", {
                    animated: false,
                    showClass: false
                })
            }
            slideToVariant(e) {
                if (e?.detail?.variant?.id) {
                    const slideIndex = this.matchVariantIdWithSlide(e.detail.variant.id);
                    if (typeof slideIndex == "number") {
                        this.goToSlide(slideIndex)
                    }
                }
            }
            matchVariantIdWithSlide(id) {
                if (!id || !this.swiperMain) {
                    return false
                }
                const slides = this.swiperMain.querySelectorAll("[data-product-variant-image]");
                const slide = [...slides].find((slide => {
                    const slideVariants = JSON.parse(slide.dataset.productVariantImage);
                    if (slideVariants.includes(id)) {
                        return slide
                    }
                }));
                if (!slide) {
                    return false
                }
                return getNodeIndex(slide)
            }
            goToSlide(slide) {
                if (typeof slide != "number" && typeof slide != "object" || !this.swiperMainInstance) {
                    return false
                }
                const index = typeof slide == "number" ? parseInt(slide) : getNodeIndex(slide);
                this.swiperMainInstance.slideTo(index)
            }
        }
        window.ProductMediaSlider = ProductMediaSlider;
        customElements.define("product-media-slider", ProductMediaSlider)
    }
})();
//# sourceMappingURL=product-media-slider.js.map